import { getField, updateField } from 'vuex-map-fields';
import axios from 'axios';

const state = {
  selectedParts: [],
  contactInformation: {
    name: '',
    companyName: '',
    email: ''
  },
  serialNumber: '',
  problemDescription: '',
  privacyConsent: '',
  updatesConsent: false,
  attachments: [],
  wilaLocation: '',
  thankYouPageUrl: '',
  loading: false
};

const actions = {
  setAttachments({ commit }, files) {
    commit('resetAttachments');

    for (const file of files) {
      const fileReader = new FileReader();
      fileReader.addEventListener('load', function() {
        const base64String = fileReader.result
          .replace('data:', '')
          .replace(/^.+,/, '');

        commit('addAttachment', {
          base64String,
          fileName: file.name
        });
      });
      fileReader.readAsDataURL(file);
    }
  },
  async submitServiceForm({ commit, state, rootState }) {
    try {
      commit('updateLoadingState', true);

      await axios.post('/Umbraco/Api/ServiceSupport/SubmitServiceForm', state, {
        params: {
          culture: rootState.culture
        }
      });

      commit('updateLoadingState', false);

      window.location.href = state.thankYouPageUrl;
    } catch (error) {
      commit('updateLoadingState', false);
      console.error(error);
    }
  },
  setThankYouPageUrl({ commit }, url) {
    commit('setThankYouPageUrl', url);
  }
};

const mutations = {
  addAttachment(state, payload) {
    state.attachments.push(payload);
  },
  resetAttachments() {
    state.attachments = [];
  },
  updateField,
  setThankYouPageUrl(state, payload) {
    state.thankYouPageUrl = payload;
  },
  updateLoadingState(state, payload) {
    state.loading = payload;
  }
};

const getters = {
  getField
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
};
